module.exports = __webpack_public_path__ + "img/showcase-instaview-en-ca.35666abe.jpg";